import {
  jb_listing_item_css_default
} from "./chunk.SQGNPDJQ.js";
import {
  Linkable,
  getLinkIconName
} from "./chunk.P6YYTXAQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Filterable
} from "./chunk.ROUIE6JK.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-listing-item/jb-listing-item.ts
var JbListingItem = class extends Filterable(Linkable(r)) {
  updated(changedProperties) {
    super.updated(changedProperties);
    if (!changedProperties.has("link") && !changedProperties.has("type")) {
      return;
    }
    const target = this.link?.target || this.link?.data?.type === "external" ? "_blank" : void 0;
    const download = !this.link?.target && this.link?.data?.type === "download";
    if (!this.link || target === this.link.target && download === this.link.download) {
      return;
    }
    this.link = { ...this.link, download, target };
  }
  render() {
    return ke`
      <div class="list-item animate ${Rt({ "icon-first": this.iconFirst })}">
        <a
          aria-label=${this.text}
          data-linkable
        >
          <span class="text">
            ${this.text} ${this.file && ke`| <span class="filetype">${this.file.type}</span>, ${this.file.size}`}
          </span>
          <div class="icon">
            <jb-svg icon=${getLinkIconName(this.link?.data?.type)}></jb-svg>
          </div>
          ${this.date && ke`<span class="second-line">${this.date}</span>`}
        </a>
      </div>
    `;
  }
};
JbListingItem.styles = jb_listing_item_css_default;
__decorateClass([
  n()
], JbListingItem.prototype, "date", 2);
__decorateClass([
  n({ type: Object })
], JbListingItem.prototype, "file", 2);
__decorateClass([
  n({ type: Boolean })
], JbListingItem.prototype, "iconFirst", 2);
__decorateClass([
  n()
], JbListingItem.prototype, "text", 2);
JbListingItem = __decorateClass([
  customElement("jb-listing-item")
], JbListingItem);

export {
  JbListingItem
};
